import QRCode from 'qrcode.react';
import { memo, MouseEvent, RefObject } from 'react';

import { IKnmSignatureInfo } from '../../../APIPackage/KnmModule/interfaces/IKnmSignatureInfo';
import { Button } from '../../../UIPackage/MainModule/components/Button';
import styles from './ErknmInfo.module.scss';
import { getDisplayedSignatureInfo } from '../../../functions/getDisplayedSignatureInfo';
import { renderDateForDisplayedSignatureInfo } from '../../../functions/renderDateForDisplayedSignatureInfo';

interface ITitleSectionElementsProps {
  isSigned: boolean | null | undefined;
  signatureInfo: IKnmSignatureInfo[] | null | undefined;
  publicPortalURL: string;
  qrRef: RefObject<HTMLDivElement>;
  accessToken?: string | null;
  handleDownloadButton: (event: MouseEvent<HTMLButtonElement>) => void;
}

export const TitleSectionElements = memo((props: ITitleSectionElementsProps) => {
  const { isSigned, signatureInfo, publicPortalURL, qrRef, accessToken, handleDownloadButton } = props;

  const displayedSignatureInfo = getDisplayedSignatureInfo(signatureInfo);

  return (
    <div className={styles.Wrapper}>
      <div className={styles.SignInfoContainer}>
        {isSigned && displayedSignatureInfo ? (
          <div className={styles.SignedContainer}>
            <div>
              <div className={styles.SignedDate}>
                Паспорт подписан {renderDateForDisplayedSignatureInfo(displayedSignatureInfo.signedDate)}{' '}
                {displayedSignatureInfo.systemSignatureUsed
                  ? `в автоматическом режиме подписью системы "${displayedSignatureInfo.systemSignatureTitle}"`
                  : ''}
              </div>
              <div>Сертификат: {displayedSignatureInfo.certInfo?.certNumber}</div>
              <div className={styles.SignedContainerName}>
                Владелец: {displayedSignatureInfo.certInfo?.subject?.name}
              </div>
              <div>
                Действителен с {renderDateForDisplayedSignatureInfo(displayedSignatureInfo.certInfo?.validFrom)} по{' '}
                {renderDateForDisplayedSignatureInfo(displayedSignatureInfo.certInfo?.validTo)}
              </div>
            </div>
            <div className={styles.SignedBorder}></div>
          </div>
        ) : (
          <div className={styles.NotSigned}>Паспорт не подписан ЭЦП</div>
        )}
      </div>
      <div className={styles.QrContainer}>
        <div className={styles.QrCanvas} ref={qrRef}>
          <QRCode value={`${publicPortalURL}/portal/public-knm/link-only/${accessToken}`} />
        </div>
        <Button variant="contained" type="button" text="Скачать QR" onClick={handleDownloadButton} />
      </div>
    </div>
  );
});
